export default [
  {
    path: '/post-search',
    name: 'post-search',
    component: () => import('@/views/postSearch/PostSearch.vue'),
    meta: {
      clinicianBlocked: true,
      printQueueUserBlocked: true,
      protected: true,
      pageTitle: 'Post Search',
      breadcrumb: [
        {
          text: 'Post Search',
          active: true,
        },
      ],
    },
  },
  {
    path: '/post/:id',
    name: 'post-view',
    props: true,
    component: () => import('@/views/postView/PostView.vue'),
    meta: {
      protected: true,
      pageTitle: 'View Post',
      breadcrumb: [
        {
          text: 'View Post',
          active: true,
        },
      ],
    },
  },
  {
    path: '/post-search-physical',
    name: 'post-search-physical',
    component: () => import('@/views/postSearch/PostSearchPhysicalView.vue'),
    meta: {
      clinicianBlocked: true,
      printQueueUserBlocked: true,
      protected: true,
      pageTitle: 'Post Search',
      breadcrumb: [
        {
          text: 'Post Search',
          active: true,
        },
      ],
    },
  },
  {
    path: '/post-search-digital',
    name: 'post-search-digital',
    component: () => import('@/views/postSearch/DigitalPostSearchView.vue'),
    meta: {
      clinicianBlocked: true,
      printQueueUserBlocked: true,
      protected: true,
      pageTitle: 'Digital Post Search',
      breadcrumb: [
        {
          text: 'Digital Post Search',
          active: true,
        },
      ],
    },
  },
  {
    path: '/print-on-site',
    name: 'print-on-site',
    props: true,
    component: () => import('@/views/printOnSite/PrintOnSiteView.vue'),
    meta: {
      protected: true,
      clinicianBlocked: true,
      printQueueUserBlocked: true,
      pageTitle: 'Print on Site',
      breadcrumb: [
        {
          text: 'Print on Site',
          active: true,
        },
      ],
    },
  },
]
